import tableTemplate from './reactIntradaysTable.html';
import { reactIntradaysCols, defaultSortModel } from './intradayDetailColDefs';
import {ReactTableController} from "../reactTableController";
import {intradayOptions} from "../../../views/administration/userReports/UserReportDetailDialogController";
import { AccountService } from '../../../services/AccountService';
import {intradays, accounts, USER_ACC_REACT} from "../../../services/arsweb/RoutingPaths";
import {REPORT_TYPE} from "../../../components/report/ReportModalController";

export const DETAILVIEW = 'app.intradayDetail';

/** @ngInject */
export function reactIntradaysTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@',
            height: '@',
            fractionDigits: '=',
            selectedKey: '@',
            withSelection: '=',
            parentController: '=',
            selectedAccounts: '=',
            hideColumns: '='
        },
        templateUrl: tableTemplate,
        controller: ReactIntradaysTableController,
        controllerAs: 'intradaysTableController'
    };
}

/** @ngInject */
export class ReactIntradaysTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies) {

        super($scope, userService, arsMainDependencies, DETAILVIEW, new AccountService(userService), accounts + intradays,
            "INTRADAYS", 'intradaysTableParams', "intradayID", false, intradayOptions, defaultSortModel);
        this.isUserReport = false;
        this.refreshAfterReport = true;
        intradayOptions.withLastAndUnread = false;
        intradayOptions.withDateRange = false;
        this.backendService.service.config.params['id'] = arsMainDependencies.$stateParams.id;
        this.backendService.service.config.params.filter = {};
        this.initGrid(userService);

        const parentOnReport = this.defaultReactGridParams.onReport;
        this.defaultReactGridParams.onReport = (selectedNodes) => {
            this.updateReportTypesForSelection();
            parentOnReport.call(this, selectedNodes);
        };
    }

    initGrid(userService) {

        userService.promise.then(()=> {
            // react account columns
            this.colDefs = reactIntradaysCols(this.translate, userService.filterFormatter, this.$scope);
            this.initCols();
            // react gridParameters for account table
            const intradaysGridParams = {
                columnDefs: this.colDefs,
                url: this.backendService.service.getServiceUrl(USER_ACC_REACT + intradays),
                onCellClicked: (row) => {
                    this.showChildDetailsView(row.data[this.rowNodeID])
                }};

            this.reactGridParams = {...this.defaultReactGridParams, ...intradaysGridParams};
        });
    }

    updateReportTypesForSelection() {
        const options = this.exportController.reportOptions.options;
        // Remove previous CAMT052 is present
        this.exportController.reportOptions.options = options.filter(opt =>
            opt !== REPORT_TYPE.CAMT052_INTRADAYS
        );

        // Add CAMT052 if flag is true for this grid
        if (this.getCamt05xFlag()) {
            this.exportController.reportOptions.options.push(REPORT_TYPE.CAMT052_INTRADAYS);
        }
    }
}
